import Header from "../components/Header/Header";
import HomeHero from "../components/Home/HomeHero";
import CasesCarousel from "../components/Home/CasesCarousel";
import CatalogPreview from "../components/Home/CatalogPreview";
import Expertise from "../components/Home/Expertise";
import HowWeWork from "../components/Home/HowWeWork";
import Certifications from "../components/Home/Certifications";
import Awards from "../components/Home/Awards";
import CtaBand from "../components/Home/CtaBand";
import ContactForm from "../components/Forms/ContactForm";
import ChatWidget from "../components/ChatWidget/ChatWidget";
import { PageSeo } from "../seo/Seo";
import { SITE_NAME, SITE_URL } from "../seo/site";
import "./Home.css";

const WEBSITE_SCHEMA = { "@type": "WebSite", name: SITE_NAME, url: SITE_URL, inLanguage: ["pt-BR", "en", "es"] };

export default function Home() {
  return (
    <div className="cz-page cz-scope cz-home">
      <PageSeo page="home" path="/" jsonLd={WEBSITE_SCHEMA} />
      <Header />
      <main>
        <HomeHero />
        <CasesCarousel />
        <Expertise />
        <CatalogPreview />
        <HowWeWork />
        <Certifications />
        <Awards />
        <CtaBand />
        <ContactForm />
      </main>
      <ChatWidget />
    </div>
  );
}
